import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SnapshotService} from 'app/core/services/snapshot.service';
import {DepartureFragment} from 'app/fragment/types/departure-fragment';

@Component({
  selector: 'das-info-banner',
  templateUrl: './info-banner.component.html',
  styleUrls: ['./info-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoBannerComponent {
  @Input() public showDas2Banner: boolean = false;
  public showSnapshotBanner: boolean = false;
  @Input() public diaryBanner: boolean = false;

  public constructor(private snapshotService: SnapshotService) {}

  @Input() public set departure(departure: DepartureFragment) {
    this.showDas2Banner = departure && departure.importedDeparture;
    this.showSnapshotBanner = this.snapshotService.viewingSnapshot();
  }
}
